module.exports = __webpack_public_path__ + "static/c1_large-7371798da2524f8999e2e2a63178e822.jpg";